import { err_reconnect_timeout } from './utils';
import { Comet } from 'shared/api/comet/comets/abstract';
const comet_session_header = 'X-ZONT-Comet-Session';
export class PollComet extends Comet {
    _session_id = null;
    _call = null;
    _abortController = null;
    mode_name() {
        return 'long-poll';
    }
    session_id() {
        return this._session_id;
    }
    call() {
        if (window.AbortController)
            this._abortController = new AbortController();
        const async_call = async () => {
            try {
                const additionalHeaders = this._session_id
                    ? { [comet_session_header]: this._session_id }
                    : undefined;
                const fetchOptions = this.api.prepareRequestParams({
                    abortSignal: this._abortController?.signal,
                    additionalHeaders,
                });
                const response = await fetch(window.ZONT_URL.comet, fetchOptions);
                if (response.status == 403) {
                    this.authError();
                    return;
                }
                if (this.active() && response.status != 200) {
                    setTimeout(() => this.call(), err_reconnect_timeout());
                    return;
                }
                const json = await response.json();
                this._session_id = response.headers.get(comet_session_header);
                if (this.active()) {
                    setImmediate(() => this.call());
                }
                const messages = json;
                for (const msg of messages)
                    this.processMessage(msg);
            }
            catch {
                if (this.active()) {
                    setTimeout(() => this.call(), err_reconnect_timeout());
                }
            }
        };
        this._call = async_call();
    }
    start() {
        console.log(`Comet ${this.mode_name()} started`);
        this._abortController?.abort();
        this.call();
    }
    stop() {
        this._abortController?.abort();
        this._session_id = null;
    }
}
